module.exports = __webpack_public_path__ + "static/recent-activity-2d01fe0e0a275a83483900d9dd4163c5.svg";